import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './banner-mid-page-full-width-item.component.scss';
import { MediaQueryService } from '../../services/media-query.service';
var BannerMidPageFullWidthItem = /** @class */ (function (_super) {
    tslib_1.__extends(BannerMidPageFullWidthItem, _super);
    function BannerMidPageFullWidthItem(element) {
        return _super.call(this, element) || this;
        // this.w = 1200;
        // this.h = 480; // initial height of the image
        // this.ratio = this.w / this.h;
    }
    BannerMidPageFullWidthItem.prototype.init = function () {
        // this.imageHolder = this.element.querySelector('.banner-mid-page-full-width-item__image-holder') as HTMLElement;
        // if(this.element.querySelector('.banner-mid-page-full-width-item__content-background')) {
        // 	this.contentBackground = this.element.querySelector('.banner-mid-page-full-width-item__content-background') as HTMLElement;
        // 	setTimeout(this.onResize.bind(this));
        // }
    };
    BannerMidPageFullWidthItem.prototype.bindEvents = function () {
        // if (this.contentBackground) {
        // 	window.addEventListener('resize', this.onResize.bind(this));
        // }
    };
    BannerMidPageFullWidthItem.prototype.onResize = function () {
        var ww = window.innerWidth;
        var el = this.element;
        el.style.opacity = '1';
        if (ww > this.w) {
            var bannerHeight = ww / this.ratio;
            var colWidth = this.w / 12;
            var cbWidth = ((ww - (12 * colWidth)) / 2) + (4 * colWidth);
            // this.imageHolder.style.height = bannerHeight + 'px';
            this.contentBackground.style.width = cbWidth + 'px';
            this.contentBackground.style.height = bannerHeight + 'px';
        }
        else {
            this.contentBackground.style.removeProperty('height');
            if (MediaQueryService.getMediaQuery() === 'small' || MediaQueryService.getMediaQuery() === 'x-small') {
                this.contentBackground.style.width = '100%';
                this.imageHolder.style.height = this.imageHolder.querySelector('img').offsetHeight + 'px';
            }
            else if (MediaQueryService.getMediaQuery() === 'medium') {
                this.imageHolder.style.removeProperty('height');
                var colWidth = ww / 12;
                this.contentBackground.style.width = (5 * colWidth) + 'px';
            }
            else {
                this.imageHolder.style.removeProperty('height');
                var colWidth = ww / 12;
                this.contentBackground.style.width = (4 * colWidth) + 'px';
            }
        }
    };
    return BannerMidPageFullWidthItem;
}(Base));
export { BannerMidPageFullWidthItem };



//////////////////
// WEBPACK FOOTER
// ./components/banner-mid-page-full-width-item/banner-mid-page-full-width-item.component.ts
// module id = 138
// module chunks = 0